/* istanbul ignore file */
import { HeatmapRecordingService } from './HeatmapRecording';

export class ClarityHeatmapRecordingServerService implements HeatmapRecordingService {
  startRecording() {
    return null;
  }

  triggerCustomEvent() {
    return null;
  }

  addCustomTag() {
    return null;
  }

  markImportantSession() {
    return null;
  }

  identify() {
    return null;
  }

  initialize() {
    return null;
  }

  giveCookieConsent() {
    return null;
  }

  revokeCookieConsent() {
    return null;
  }
}
